/**
 * 股票信息
 */

import React, { PureComponent } from 'react';
import NoSSR from 'react-no-ssr';
import styles from './index.css';

class Shares extends PureComponent {
    iframe = `<iframe
    class="${styles.iframe}"
    src="https://unews.fx678.com/union/HaoSTZ/EC/Fhw/FhwInterface.html"
    scrolling="no"
    frameBorder="0"
    border="0"
></iframe>`;

    render() {
        return (
            <div className={styles.shares}>
                <NoSSR>
                    <div dangerouslySetInnerHTML={{ __html: this.iframe }} />
                    <p>
                        数据来源：
                        <a className={styles.laiyuan} href="http://www.fx678.com/" target="_blank" rel="noreferrer">
                            汇通网
                        </a>
                    </p>
                </NoSSR>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Shares.propTypes = {};

/**
 * 定义组件默认属性
 * */
Shares.defaultProps = {};

export { Shares };
export default Shares;
